import { post } from "../Server";
import { useSearchParams } from "react-router-dom";

export const useSearchObject = () => {
  const findNestedObj = (entireObj, keyToFind, valToFind) => {
    let foundObj;
    JSON.stringify(entireObj, (_, nestedValue) => {
      if (nestedValue && nestedValue[keyToFind]) {
        foundObj = nestedValue;
      }
      return nestedValue;
    });
    return foundObj;
  };
  return {
    findNestedObj,
  };
};

export const logOut = () => {
  const logout = async () => {
    const { data, status } = await post("/logout");
    if (+status === 200) {
      localStorage.removeItem("user");
      window.location.replace("/");
    }
  };
  return { logout };
};
export const useQuery = ({ filters = [{ key: "page" }] }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const changeObj = (key, value) => {
    let obj = {};
    filters.map(element => {
      if (searchParams.get(element.key)) {
        obj = { ...obj, [element.key]: searchParams.get(element.key) };
      }
    });
    setSearchParams({ ...obj, [key]: value });
  };
  const createObjFilter = () => {
    let obj = {};
    filters.map(element => {
      if (searchParams.get(element.key)) {
        obj = { ...obj, [element.key]: searchParams.get(element.key) };
      }
    });
    return obj;
  };
  const getValue = key => {
    return key ? searchParams.get(key) || false : false;
  };
  const clear = () => {
    setSearchParams({});
  };
  return {
    createObjFilter,
    changeObj,
    searchParams,
    createObjFilter,
    getValue,
    clear,
  };
};
